import React from 'react';
import { motion } from 'framer-motion';
import { languages } from '../utils/i18n';

const LanguageSelector = ({ currentLanguage, onLanguageChange }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed top-6 left-6 z-50"
    >
      <select
        value={currentLanguage}
        onChange={(e) => onLanguageChange(e.target.value)}
        className="bg-pantone-blue/20 backdrop-blur-md border border-pantone-blue/30 rounded-lg px-4 py-2 text-white text-sm focus:outline-none focus:border-pantone-blue/50 transition-all duration-300"
      >
        {Object.entries(languages).map(([code, name]) => (
          <option key={code} value={code} className="bg-gray-900 text-white">
            {name}
          </option>
        ))}
      </select>
    </motion.div>
  );
};

export default LanguageSelector;